module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightsomecloud-224c0e61f74dda4286da17463e766796.svg";